import Navbar from "../components/Layout/Navbar";
import Footer from "../components/Layout/Footer";
import workplan from "../data/workplan";

function formatDate() {
  return new Date().toLocaleDateString("en-US", {
    weekday: "long",
    day: "numeric",
    month: "long",
    year: "numeric",
  });
}

function Workplan() {
  return (
    <>
      <Navbar />

      <div className="container mx-auto px-20">
        <div className="mt-6 mb-10">
          <h2 className="text-2xl font-semibold mb-2">
            WORK PLAN UNGEGN ASIA SOUTH-EAST DIVISION (ASE DIVISION)
          </h2>
          <p className="text-sm text-gray-600">{formatDate()}</p>
        </div>

        {/* RENDER SEMUA SECTION DARI DATA */}
        {workplan.map((section) => (
          <Section
            key={section.id}
            title={section.title}
            description={section.description}
            items={section.items}
          />
        ))}
      </div>

      <Footer />
    </>
  );
}

/* ===== Reusable Components ===== */

function Section({ title, description, items }) {
  return (
    <div className="mb-12">
      <h3 className="text-xl font-semibold mb-2">{title}</h3>
      <p className="mb-6 text-gray-700">{description}</p>

      <div className="grid grid-cols-1 sm:grid-cols-2 md:grid-cols-4 gap-4">
        {items.map((item, index) => (
          <div
            key={index}
            className="border rounded-lg p-4 shadow-sm hover:shadow-md transition mb-8"
          >
            <h4 className="text-lg font-bold mb-2">{item.year}</h4>
            <p className="text-sm text-gray-700 whitespace-pre-line">{item.text}</p>
          </div>
        ))}
      </div>
    </div>
  );
}

export default Workplan;
